/* ============================================
   Toptal Clone - Sapphire Craft Theme
   Interactive JavaScript
   ============================================ */

document.addEventListener('DOMContentLoaded', function() {

  /* --- Intersection Observer for reveal animations --- */
  const revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length) {
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function(el) { observer.observe(el); });
  }

  /* --- Navbar scroll effect --- */
  var navbar = document.getElementById('main-navbar');
  if (navbar) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 10) {
        navbar.classList.add('navbar-scrolled');
      } else {
        navbar.classList.remove('navbar-scrolled');
      }
    });
  }

  /* --- Announcement bar close --- */
  var closeBtn = document.getElementById('close-announcement');
  var announcementBar = document.getElementById('announcement-bar');
  if (closeBtn && announcementBar) {
    closeBtn.addEventListener('click', function() {
      announcementBar.style.display = 'none';
    });
  }

  /* --- Hero tab switcher --- */
  var heroTabs = document.querySelectorAll('.hero-tab');
  var heroHeading = document.getElementById('hero-heading');
  var heroDescription = document.getElementById('hero-description');
  var heroPrimaryCta = document.getElementById('hero-primary-cta');
  var heroSecondaryCta = document.getElementById('hero-secondary-cta');
  var heroStatValues = document.querySelectorAll('.hero-stat-value');
  var heroStatLabels = document.querySelectorAll('.hero-stat-label');
  var heroBadgeEyebrow = document.getElementById('hero-badge-eyebrow');
  var heroBadgeTitle = document.getElementById('hero-badge-title');
  var heroPanels = document.querySelectorAll('.hero-panel');

  heroTabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var activeMode = this.dataset.heroMode;

      heroTabs.forEach(function(t) {
        t.classList.remove('active');
        t.style.background = 'transparent';
        t.style.color = '#64748b';
      });
      this.classList.add('active');
      this.style.background = '#2563eb';
      this.style.color = '#fff';

      if (heroHeading && this.dataset.heading) heroHeading.textContent = this.dataset.heading;
      if (heroDescription && this.dataset.description) heroDescription.textContent = this.dataset.description;

      if (heroPrimaryCta) {
        heroPrimaryCta.textContent = this.dataset.primaryText || heroPrimaryCta.textContent;
        heroPrimaryCta.setAttribute('href', this.dataset.primaryUrl || '#');
      }

      if (heroSecondaryCta) {
        heroSecondaryCta.textContent = this.dataset.secondaryText || heroSecondaryCta.textContent;
        heroSecondaryCta.setAttribute('href', this.dataset.secondaryUrl || '#');
      }

      heroStatValues.forEach(function(valueEl, index) {
        var value = tab.dataset['stat' + (index + 1) + 'Value'];
        if (value) valueEl.textContent = value;
      });

      heroStatLabels.forEach(function(labelEl, index) {
        var label = tab.dataset['stat' + (index + 1) + 'Label'];
        if (label) labelEl.textContent = label;
      });

      if (heroBadgeEyebrow && this.dataset.badgeEyebrow) heroBadgeEyebrow.textContent = this.dataset.badgeEyebrow;
      if (heroBadgeTitle && this.dataset.badgeTitle) heroBadgeTitle.textContent = this.dataset.badgeTitle;

      heroPanels.forEach(function(panel) {
        panel.style.display = panel.dataset.heroPanel === activeMode ? 'flex' : 'none';
      });
    });
  });

  /* --- Hero talent carousel --- */
  var talentBtns = document.querySelectorAll('.talent-carousel-btn');
  var floatingName = document.getElementById('floating-card-name');
  var floatingRole = document.getElementById('floating-card-role');
  var floatingField = document.getElementById('floating-card-field');
  var floatingCompany = document.getElementById('floating-card-company');
  var floatingAvatar = document.getElementById('floating-card-avatar');

  talentBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      talentBtns.forEach(function(b) {
        b.style.background = 'rgba(255,255,255,0.6)';
        b.style.borderColor = '#e2e8f0';
        b.style.boxShadow = 'none';
      });
      this.style.background = '#fff';
      this.style.borderColor = 'rgba(37, 99, 235, 0.3)';
      this.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)';

      if (floatingName) floatingName.textContent = this.dataset.name;
      if (floatingRole) floatingRole.textContent = this.dataset.role;
      if (floatingField) floatingField.textContent = this.dataset.field;
      if (floatingCompany) floatingCompany.textContent = this.dataset.company;
      if (floatingAvatar) floatingAvatar.src = this.dataset.img;
    });
  });

  /* --- Ranking accordion --- */
  var accordionBtns = document.querySelectorAll('.accordion-btn');
  accordionBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var content = this.nextElementSibling;
      var icon = this.querySelector('.accordion-icon');
      var isOpen = content.style.maxHeight && content.style.maxHeight !== '0px';

      // Close all
      document.querySelectorAll('.accordion-content').forEach(function(c) {
        c.style.maxHeight = '0px';
        c.style.opacity = '0';
      });
      document.querySelectorAll('.accordion-icon').forEach(function(ic) {
        ic.style.transform = 'rotate(0deg)';
      });

      // Toggle current
      if (!isOpen) {
        content.style.maxHeight = content.scrollHeight + 'px';
        content.style.opacity = '1';
        if (icon) icon.style.transform = 'rotate(180deg)';
      }
    });
  });

  /* --- Talent Network tabs --- */
  var networkTabs = document.querySelectorAll('.network-tab');
  var networkPanels = document.querySelectorAll('.network-panel');
  networkTabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var target = this.dataset.tab;
      networkTabs.forEach(function(t) {
        t.classList.remove('active');
        t.style.background = 'transparent';
        t.style.color = '#64748b';
      });
      this.classList.add('active');
      this.style.background = '#2563eb';
      this.style.color = '#fff';

      networkPanels.forEach(function(panel) {
        if (panel.dataset.panel === target) {
          panel.style.display = 'grid';
        } else {
          panel.style.display = 'none';
        }
      });
    });
  });

  /* --- Testimonial navigation --- */
  var testimonialDots = document.querySelectorAll('.testimonial-dot');
  var testimonialSlides = document.querySelectorAll('.testimonial-slide');
  var currentSlide = 0;

  function showSlide(index) {
    testimonialSlides.forEach(function(s) { s.style.display = 'none'; });
    testimonialDots.forEach(function(d) {
      d.style.background = '#cbd5e1';
      d.style.width = '8px';
    });
    if (testimonialSlides[index]) testimonialSlides[index].style.display = 'block';
    if (testimonialDots[index]) {
      testimonialDots[index].style.background = '#2563eb';
      testimonialDots[index].style.width = '24px';
    }
    currentSlide = index;
  }

  testimonialDots.forEach(function(dot, i) {
    dot.addEventListener('click', function() { showSlide(i); });
  });

  var prevBtn = document.getElementById('testimonial-prev');
  var nextBtn = document.getElementById('testimonial-next');
  if (prevBtn) prevBtn.addEventListener('click', function() {
    showSlide(currentSlide > 0 ? currentSlide - 1 : testimonialSlides.length - 1);
  });
  if (nextBtn) nextBtn.addEventListener('click', function() {
    showSlide(currentSlide < testimonialSlides.length - 1 ? currentSlide + 1 : 0);
  });

  /* --- Mobile nav toggle --- */
  var mobileToggle = document.getElementById('mobile-nav-toggle');
  var mobileMenu = document.getElementById('mobile-menu');
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', function() {
      var isOpen = mobileMenu.style.display === 'block';
      mobileMenu.style.display = isOpen ? 'none' : 'block';
    });
  }

});
